export class LocationSales {
    id: number;
    name: string;
    subtotal: number;
    tax: number;
    total: number;
    spare: number;
    lastInvoice:string;
     
    constructor(data: any) {
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/shared/models/location-sales.ts